export interface EmployeeHoursPerWeek {
  employeeID: string | null;
  factor: number | null;
  hours: number | null;
  workingHours: number | null;
  nonWorkingHours: number | null;
  gateHoursOnDate: number | null;
  gateDate: Date | null;
  hoursWorkedOnDate: number | null;
  hoursLeftOnGate: number;
  gateHoursOnDateAndShift: number | null;
  hoursLeftOnGateAndShift: number;
  hoursWorkedOnDateAndShift: number | null;
  jobs: string[];
  absentReasonID: string | null;
  absentReason: string | null;
  datePerDiems: DatePerDiem[];
  employeeMileages: Mileage[];
  dateJobHours: DateJobHours[];
  earnCodeHours: EarnCodeHours[];
  foremanEarnCodeHours: ForemanEarnCodeHours[];
  foremanDateJobHours: ForemanDateJobHours[];
}

export interface DateJobHours {
  employeeID: string;
  factor: number | null;
  date: Date | null;
  job: string | null;
  hours: number | null;
  earnCode: string | null;
  earnCodeDesc: string | null;
  bNonWorkingHrs: boolean | null;
}

export interface EarnCodeHours {
  employeeID: string;
  factor: number | null;
  earnCodeType: string | null;
  earnCode: string | null;
  hours: number | null;
  bNonWorkingHrs: boolean | null;
}

export interface DatePerDiem {
  date: Date | null;
  perDiemRecorded: boolean | null;
  perDiemPhase: string | null;
  perDiemRate: number | null;
  perDiemSummary: string | null;
  perDiemCount: number | null;
}

export interface Mileage {
  date: Date | null;
  vpJobID: string | null;
  phase: string | null;
  mileage: number;
  mileageType: string | null;
}

export interface ForemanEarnCodeHours {
  employeeID: string;
  earnCodeType: string | null;
  hours: number | null;
  isNonWorking: boolean | null;
  order: number | null;
}

export interface ForemanDateJobHours {
  employeeID: string;
  earnCodeType: string | null;
  date: Date | null;
  job: string | null;
  hours: number | null;
  earnCode: string | null;
  bNonWorkingHrs: boolean | null;
  isNonWorking: boolean | null;
  order: number | null;
}
